import { render, staticRenderFns } from "./DashboardWorkshopManager.vue?vue&type=template&id=30cc1392"
import script from "./DashboardWorkshopManager.vue?vue&type=script&lang=js"
export * from "./DashboardWorkshopManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports